<div class="item-prices" [class.item-prices--compact]="compact()">
  @if (basePrice()) {
    <div>
        <pwj-text-summarizer
          [text]="(basePrice()?.[currentCurrency] | number) || '_'"
          [truncate]="compact()"
          [limitLength]="summarizingLength()">
        </pwj-text-summarizer>

      <span>
        {{
          currentCurrency === 'usd'
            ? '$'
            : ('enums.currencies.' + currentCurrency | translate)
        }}
      </span>
    </div>
  } @else if (
    highestPrice()?.[currentCurrency] || lowestPrice()?.[currentCurrency]
  ) {
    <div class="item-prices__price-range">
      @if (highestPrice()?.[currentCurrency]) {
        <pwj-text-summarizer
          [text]="(highestPrice()?.[currentCurrency] | number) || '_'"
          [truncate]="compact()"
          [limitLength]="summarizingLength()">
        </pwj-text-summarizer>
      }
      <span> - </span>
      @if (lowestPrice()?.[currentCurrency]) {
        <pwj-text-summarizer
          [text]="(lowestPrice()?.[currentCurrency] | number) || '_'"
          [truncate]="compact()"
          [limitLength]="summarizingLength()">
        </pwj-text-summarizer>
      }

      <span>
        {{
          currentCurrency === 'usd'
            ? '$'
            : ('enums.currencies.' + currentCurrency | translate)
        }}
      </span>
    </div>
  } @else {
    <p class="item-prices__agreed">
      {{ 'global.agreedPrice' | translate }}
    </p>
  }
</div>
